import { useQuery } from '@tanstack/react-query';
import { useOkapiKy } from '@folio/stripes/core';

export const DASHBOARDS_QUERY_KEY = 'dashboards';

export default function useDashboardsAPI() {
  const okapiKy = useOkapiKy();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [DASHBOARDS_QUERY_KEY],
    queryFn: () => okapiKy.get('dashboards?limit=1000').json(),
    staleTime: 2 * 60 * 1000,
  });

  return {
    dashboards: data?.dashboards || [],
    totalRecords: data?.totalRecords || 0,
    isLoading,
    error,
    refetch,
  };
}
